import { Reveal, Chapter } from "./Reveal";

const STATS = [
  { value: "1988", label: "Established in Kota, Rajasthan" },
  { value: "1L+ sq ft", label: "Total production area" },
  { value: "03", label: "Integrated manufacturing units" },
];

const FOUNDERS = [
  { name: "Raj Narayan Garg", role: "Founder" },
  { name: "Aditya Garg", role: "Next Generation" },
];

const About = () => (
  <section id="origins" className="relative bg-ink px-6 md:px-12 lg:px-20 py-28 md:py-36" data-testid="about-section">
    <div className="grid grid-cols-1 md:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] gap-8 md:gap-12 lg:gap-20 items-start">
      <Reveal className="min-w-0" data-testid="about-image-wrap">
        <div className="relative">
          <div className="group relative overflow-hidden aspect-[4/5] bg-stone">
            <img
              src="/catalog/founders-clean.jpg"
              alt="Adv. Raj Narayan Garg, Founder, with Aditya Garg, Next Generation — Garg Stone Company"
              loading="lazy"
              className="h-full w-full object-cover grayscale-[30%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
              data-testid="about-image"
            />
            <div className="absolute inset-x-0 bottom-0 grid grid-cols-2 gap-4 p-5 md:p-7" data-testid="about-founder-names">
              {FOUNDERS.map((f, i) => (
                <div key={f.name} className={i ? "text-right" : ""} data-testid={`about-founder-${i}`}>
                  <p className="font-heading font-bold uppercase tracking-[0.12em] text-xs sm:text-sm text-bone leading-snug">{f.name}</p>
                  <p className="mt-1 text-[10px] tracking-[0.3em] uppercase font-heading text-copper">{f.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>

      <div className="min-w-0 flex flex-col gap-8 mt-10 md:mt-0">
        <Reveal>
          <Chapter index="01" title="Origins" testid="about-chapter" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight leading-[1.05]" data-testid="about-heading">
            Rooted in Kota.{" "}
            <span className="font-editorial italic font-medium text-copper">Built on trust.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18} className="flex flex-col gap-5 max-w-xl">
          <p className="text-base md:text-lg font-light leading-relaxed text-bone/70">
            Garg Stone Company was started in 1988 by Advocate Raj Narayan Garg
            with a clear vision — serve Kota through quality natural stone and
            build lasting relationships. His dedication to the industry led him to
            serve as President of the Hadoti Kota Stone Industrial Association.
          </p>
          <p className="text-base md:text-lg font-light leading-relaxed text-bone/70">
            Today, his son Aditya Garg carries the business forward with the same
            commitment, combining tradition with a modern approach. Same stone,
            stronger spaces — quality, consistency and long-term partnerships.
          </p>
        </Reveal>

        <Reveal delay={0.26}>
          <div className="grid grid-cols-3 border-t border-bone/10" data-testid="about-stats">
            {STATS.map((s, i) => (
              <div key={s.label} className={`min-w-0 py-6 pr-2 lg:pr-4 ${i ? "border-l border-bone/10 pl-2 lg:pl-5" : ""}`} data-testid={`about-stat-${i}`}>
                <p className="font-heading font-extrabold text-2xl lg:text-3xl text-bone">{s.value}</p>
                <p className="mt-2 text-[10px] lg:text-xs font-light text-bone/50 leading-snug break-words">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.32}>
          <p className="text-xs tracking-[0.25em] uppercase font-heading text-bone/40" data-testid="about-exhibitions">
            Exhibiting at D-ARC Build Expo, New Delhi & STONA, Bangalore
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
